export function emailVerificationStatus(record) {
  const raw = record?.EMAIL_VERIFIED ?? record?.email_verified ?? record?.IS_EMAIL_VERIFIED;
  if (raw === true || raw === 1 || String(raw).toLowerCase() === "true" || String(raw) === "1") return true;
  if (raw === false || raw === 0 || String(raw).toLowerCase() === "false" || String(raw) === "0") return false;
  return null;
}
